// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosPromise } from 'axios';
import { IProduct } from '../redux/actionCreators/home/getHomeActions';

import { Member } from '../types/Model';
import { authGet, authPost, authPut, parseCamelCase, parseSnakeCase, get, post } from './util';

// Member
export async function getMe(): Promise<Member> {
  return authGet('/member/me').then(({ data }: any) => {
    const parsed = parseCamelCase(data);
    parsed.isManager = parsed.isManager === true;
    return parsed;
  })
}

export async function updateMe(data: any): Promise<any> {
  console.log('updateMe', data);
  return await authPost('/member/me', parseSnakeCase(data));
}

// Notification
export const getNotifications = (page: number, limit: number): AxiosPromise => {
  return authGet(`/member/notifications?page=${page}&limit=${limit}`, {
    transformResponse: ({ count, limit, list, page, totalPage, unread }: any) => {
      return {
        count,
        limit,
        page,
        totalPage,
        unread,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        list: list.map((notification: any, index: number) => ({
          id: notification.id,
          notificationType: notification.notification_type,
          notificationProps: parseCamelCase(notification.notification_props),
          link: notification.link,
          time: new Date(notification.created_time),
          read: notification.read
        }))
      };
    }
  });
};
export const getResetNotifications = (): AxiosPromise => {
  return authGet('/member/resetNotification', { transformResponse(data) { return parseCamelCase(data) }})
};
export const deleteNotifications = (ids: number[]): AxiosPromise => {
  return authPost('/member/deleteNotifications', { ids });
};

export const readNotification = (id: number): AxiosPromise => {
  return authPut(`/member/notifications/${id}`, { read: true });
};

export const readAllNotifications = (): AxiosPromise => {
  return authPost('/member/readAllnotifications');
};

export const postJoinOrganization = (invitation: string): AxiosPromise => {
  return authPost('/member/joinOrganization', { code: invitation });
}

export const getHome = (): AxiosPromise => {
  return authGet('/member/home', {
    transformResponse: (data: unknown) => {
      return parseCamelCase(data).map((progress: IProduct) => ({
        ...progress,
        completionTime: progress.completionTime ? new Date(progress.completionTime) : null,
        startTime: 'startTime' in progress && progress.startTime ? new Date(progress.startTime): null,
        endTime: 'endTime' in progress && progress.endTime ? new Date(progress.endTime): null,
        latestTime: 'latestTime' in progress && progress.latestTime ? new Date(progress.latestTime): null,
      }));
    }
  });
}

export const getHistory = (type: string): AxiosPromise => {
  const query = `?type=${type}`;
  return authGet(`/member/getHandsOnHistory${query}`, {
    withCredentials: true,
    transformResponse: (data: any) => {
      const parsed = parseCamelCase(data);

      return parsed;
    }
  });
};

export const getAuthToken = (id: string): AxiosPromise => {
  return get(`/member/checkAuth?uuid=${id}`, {
    withCredentials: true,
    transformResponse: (data: any) => {
      return data;
    }
  });
};

export const checkLoginMethod = (email: string): AxiosPromise => {
  return post('/member/checkLoginMethod', parseSnakeCase({
    email
  }), {
    transformResponse: (data: any) => parseCamelCase(data)
  });
};
